export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: {
        Statistics: 'Statistics',
        "MANAGE_STORE": "Manage Store",
        "NOTIFICATIONS": "Notifications",
        "STORES": "Stores",
        "MERCHANTS": "Merchants",
        "SUPPORT": "Support",
        "BUY_NOTIFICATIONS_CREDIT": "Buy Notifications Credit",
        title: "Stores",
        description: "All Stores listed in the system...",
        show: "Show",
        search: "Search",
        name: "Name",
        descriptions: "Description",
        menu: "Menu",
        logo: "Logo",
        address: "Address",
        category: "Category",
        managedBy: "Managed By",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        "NOTIFICATION_PACKAGES": "Notification Packages",
        "STATISTICS": "Statistics",
        "ALL_STATISTICS_LISTED": "All statistics listed in the system...",
        "SHOW": "Show",
        "SEARCH": "Search",
        "SUPPLIER": "Supplier",
        "ACTIONS": "Actions",
        "ITEMS": "Items",
        "DETAILS": "Details",
  "ALL_MANAGE_STORE_LISTED": "All Manage Store listed in the system...",
  "ALL_NOTIFICATIONS_LISTED": "All Notifications listed in the system...",
  "ALL_MERCHANTS_LISTED": "All Merchants listed in the system...",
  "NAME": "Name",
  "ENTER_NAME": "Enter Name",
  "EMAIL": "Email",
  "ENTER_EMAIL": "Enter Email",
  "MANAGED_STORE": "Managed Store ( Name , Logo )",
  "ALL_SUPPORT_LISTED": "All Support listed in the system...",
  "ALL_NOTIFICATION_PACKAGES_LISTED": "All Notification Packages listed in the system...",
  "PRICE": "Price",
  "DURATION": "Duration",
  "USAGE_LIMIT": "Usage Limit",
  "STORE_OFFERS": "Store Offers",
  "ADDRESS": "Address",
  "ADD_OFFER": "Add Offer",
  "TITLE": "Title",
  "PHOTO": "Photo",
  "ORIGINAL_PRICE": "Original Price",
  "DISCOUNT": "Discount",
  "REQUIRED_POINTS": "Required Points",
   "STORE_GALLERY": "Store Gallery",
   "ADD_STORE": "Add Store",
   "UPLOAD_LOGO": "Upload Logo",
   "CATEGORY": "Category",
   "SELECT_STORE_CATEGORY": "Select Store Category...",
   "STORE_MANAGER": "Store Manager",
   "SELECT_STORE_MANAGER": "Select Store Manager...",
   "DESCRIPTION": "Description",
   "MENU_URL": "Menu URL",
   "OPENING_TIME": "Opening Time",
   "CLOSING_TIME": "Closing Time",
   "SAVE": "Save",  
   "Password": "Password",  
   "PLACEHOLDER_NAME": "Name...",
   "PLACEHOLDER_Password": "Password...",
   "PLACEHOLDER_DESCRIPTION": "Description...",
   "PLACEHOLDER_MENU_URL": "Menu URL...",
   "PLACEHOLDER_ADDRESS": "Address...",
   "PLACEHOLDER_OPENING_TIME": "Opening time...",
   "PLACEHOLDER_CLOSING_TIME": "Closing time...",
     "PLACEHOLDER_EMAIL": "Email...",
  "ADD_MERCHANT": "Add Merchant",
  "SUPPORT_TICKETS": "Support Tickets",
  "ALL_SUPPORT_TICKETS": "All Support Tickets listed in the system...",
  "STATUS": "Status",
  "LAST_UPDATED": "Last Updated",
  "ALL_STORE_CATEGORIES": "All Store Categories listed in the system...",
  "STORE_CATEGORIES": "Store Categories",
  "ADD_STORE_CATEGORIES": "Add Store Categories",
"ADD_NOTIFICATION_PACKAGE": "Add Notification Package",
  "UPLOAD_ICON": "Upload Icon",

  "PLACEHOLDER_DURATION": "Enter duration...",
  "PLACEHOLDER_PRICE": "Enter price...",
  "PLACEHOLDER_USAGE_LIMIT": "Enter usage limit...",
  "ADD_PACKAGE": "Add Package",
  "OPEN_SUPPORT_TICKET": "Open Support Ticket",
  "SELECT_CATEGORY": "Select a Category...",
  "PLACEHOLDER_TITLE": "Enter title...",
  "SEND_REQUEST": "Send Request",
  "BUY_NOTIFICATION_CREDIT": "Buy Notification Credit",
  "ALL_BUY_NOTIFICATION_CREDIT": "All Buy Notification Credit listed in the system...",
  "STORE_QR_CODE": "Store QR Code",
  "TARGET_LINK": "Target link",
  "VALID_TARGET_LINK": "Please enter a valid Target Link.",
  "DOWNLOAD_QR": "Download QR",
  "GENERATE_UPDATE_QR": "Generate / Update QR",
  "TARGET_LINK_PLACEHOLDER": "target link ...",
  "AVAILABLE_PACKAGES": "Available Packages",
  "STORE_NOTIFICATIONS": "Store Notifications",
  "USED": "Used",
  "NOTIFICATIONS_PREMIUM": "Notifications Premium",
  "NOTIFICATIONS_SENT": "75 out of 100 notifications sent",
  "END_DATE": "End on 21/05/2025",
  "ACTIVE": "Active",
  "RENEW_SUBSCRIPTION": " Purchase a new notification package",
  "SEND_NOTIFICATIONS": "Send Notifications",
  "SEARCH_USERS": "Search users...",
      "SORT_BY": "Sort By",
      "OTHER_DETAILS": "Other Details...",
      "MEMBERSHIP_NAME": "Membership Name",
      "POINTS_AVAILABLE": "Available Points",
      "QR_USE_COUNT": "QR Use Count",
      "LAST_QR_USE": "Last QR Use",
      "FROM_DATE": "From Date",
      "TO_DATE": "To Date",
      "GET_DATA": "Get Data",
      "STORE_STATISTICS": "Store Statistics",
      "OLD_USERS": "Old Users",
      "NEW_USERS": "New Users",
      "QR_SCANS_THIS_YEAR": "QR Code Scans This Year",
      "QR_SCANS_THIS_MONTH": "QR Code Scans This Month",
      "QR_SCANS_THIS_WEEK": "QR Code Scans This Week",
      "QR_SCANS_TODAY": "Total QR Code Scans Today",
      "USERS": "Users",
      "AGGREGATE_STATISTICS": "Aggregate Statistics",
      "TOTAL_APP_DOWNLOADS": "Total App Downloads",
      "TOTAL_NUMBER_OF_STORES": "Total Number Of Stores",
      "TOTAL_NUMBER_OF_USERS": "Total Number Of Users",
      "TOTAL_QR_CODE_SCANS_ON_APP": "Total QR Code Scans On App",
      "STORES_SORTED_BY_MOST_QR_SCANS": "Stores sorted by most QR code scans",
      "LOGO": "Logo",
      "TOTAL_QR_CODE_SCANS": "Total QR Code Scans",
      "GENERATE_QR": "Generate QR",
      "ADD_OFFERS": "Add Offers"





      },
    },
  
 
  }
};
